import { defineRouting } from 'next-intl/routing';
export type Locale = (typeof routing.locales)[number];
export const routing = defineRouting({
  locales: ['en', 'uz', 'ru'],
  defaultLocale: 'ru',
  localePrefix: 'always',
  localeDetection: false,
});
